import React, { useState, useEffect, Fragment, memo, useContext } from 'react';
import { Formik, Form } from 'formik';
import Style from './LogInDetails.module.css';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import get from 'lodash/get';
import {
  getBankCities,
  uploadProcessingFee,
  processingFeeuploaded,
  UploadFileToS3,
  saveLoginDetailsapi,
  getLoginDetailsApi,
  getFincialInstitutions
} from '../../../common/constants/api';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
const initialImg = '/images/icons/upload_new.svg';
import _ from 'lodash';
import * as Yup from 'yup';
import moment from 'moment';

import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import PopUp from '../../../common/components/PopUp/PopUp';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import ShowDoc from '../../../containers/CMDashboard/ShowDoc';
import { numberFormat } from '../../../common/constants/NumberFormat';
import CommonDatePicker from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import { enableGATracking } from 'gatsby-env-variables';
import CMRejectLead from '../CMRejectLead/CMRejectLead';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import RejectedBankLogin from './RejectedBankLogins';

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))(Tooltip);

const updateLeadStatus = async setTriggerStatusUpdate => {
  if (localStorage.hasOwnProperty('applicantionInfo')) {
    let leadInfo = JSON.parse(localStorage.getItem('applicantionInfo'));
    leadInfo.applicationStatus = 'Login';
    localStorage.setItem('applicantionInfo', JSON.stringify(leadInfo));
    setTriggerStatusUpdate('Login');
  } else {
    throw new Error('applicationInfo Key word error in local storage');
  }
};

const validationSchema = Yup.object().shape({
  city: Yup.string().required('Required'),
  bankname: Yup.string().required('Required'),
  fileID: Yup.string().required('Required'),
  yesOrno: Yup.string().required('Required'),
  amount: Yup.number()
    .required('required')
    .lessThan(Yup.ref('loanAmount'), 'Should be less than loan amount'),
  date: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  month: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  year: Yup.object().shape({
    value: Yup.string().required('Required')
  })
});

const LogInDetails = ({ setTriggerStatusUpdate }) => {
  const {
    container_align,
    logInDocBox,
    rotatge_45_clock,
    loginDateContainer
  } = Style;
  const [cityOptions, setCityOptions] = useState([]);
  const [bankListOptions, setBankListOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading');
  const [status, setStatus] = useState(false);
  const [processingId, setProcessingId] = useState(false);
  const [lead_Id, setLead_id] = useState(getApplicantionInfo().leadId);
  const [getresponse, setResponse] = useState(true);
  const [getDocResponse, setDocResponse] = useState();
  const [showAllDetails, setShowAllDetails] = useState(false);
  const [dontClose, setDontClose] = useState(true);
  const [fullImage, setFullImage] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  return (
    <Formik
      initialValues={{
        city: { value: '', label: 'Select City' },
        bankname: { value: '', label: 'Select Bank' },
        yesOrno: true,
        fileID: '',
        file: [],
        imgUrl: [],
        isEditMode: false,
        amount: '',
        loanAmount: 0,
        date: {
          value:
            parseInt(moment().format('DD')) < 10
              ? moment().format('D')
              : moment().format('DD'),
          label: moment().format('DD')
        },
        month: {
          value: moment().format('MM'),
          label: moment().format('MMMM')
        },
        year: {
          value: moment().format('YYYY'),
          label: moment().format('YYYY')
        }
      }}
      validationSchema={validationSchema}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting,
        validateForm
      }) => {
        useEffect(() => {
          let data = getApplicantionInfo();
          if (data?.loanAmount) {
            setFieldValue('loanAmount', parseInt(data.loanAmount) + 1);
          }
        }, []);

        const resetState = () => {
          setShow(true);
          setType('loading');
          setText('Loading');
          setStatus(false);
          setDontClose(true);
        };
        useEffect(() => {
          resetState();
          getBankCities()
            .then(res => {
              setShow(false);
              let cities = [];
              res?.map(item => {
                let city = {
                  value: item.id,
                  label: item.name
                };
                cities.push(city);
              });
              setCityOptions(cities);
            })
            .catch(err => {
              setShow(false);
            });
        }, []);

        useEffect(() => {
          getFincialInstitutions(0, 200)
            .then(res => {
              setShow(false);
              let banks = [];
              res?._embedded?.insituteDetailDtoList?.map(item => {
                let bank = {
                  value: item?.id,
                  label: item?.brandName
                };

                banks.push(bank);
              });

              setBankListOptions(banks);
            })
            .catch(err => {
              setShow(false);
            });
        }, []);

        //upload api
        async function fileUpload() {
          setType('loading');
          setText('Uploading the File Please Wait...');
          setShow(true);
          setDontClose(true);
          await uploadProcessingFee(lead_Id)
            .then(res => {
              setProcessingId(res?.requestId);
              UploadFileToS3(res.url, values.file[0][0]).then(() => {
                processingFeeuploaded(lead_Id, res?.requestId || '').then(
                  res => {
                    setType('success');
                    setText('File uploaded successfully.');
                    setShow(true);
                    setDontClose(false);
                  }
                );
              });
            })
            .catch(err => {
              setShow(false);
            });
        }
        useEffect(() => {
          if (values?.file[0] && values?.file[0][0]) {
            fileUpload();
          }
        }, [values?.file[0]]);

        // save api
        const saveLoginDetails = () => {
          setType('loading');
          setText('submitting Data Please Wait...');
          setShow(true);
          setDontClose(true);
          let body = {
            cityId: values?.city?.value,
            cityName: values?.city?.label,
            bankId: values?.bankname?.value,
            bankName: values?.bankname?.label,
            fileId: values?.fileID,
            processingFeePaid: values?.yesOrno,
            loginAmount: values?.amount,
            loginDate: `${values?.year?.value ||
              moment().format('YYYY')}-${_.padStart(
              values?.month?.value,
              2,
              '0'
            ) || moment().format('MM')}-${_.padStart(
              values.date?.value,
              2,
              '0'
            ) || moment().format('DD')}`
          };
          if (values?.yesOrno && processingId) {
            body['processingFeesDocId'] = processingId;
          }

          saveLoginDetailsapi(lead_Id, body)
            .then(res => {
              setShow(false);
              setShowAllDetails(true);
              updateLeadStatus(setTriggerStatusUpdate);
              if (enableGATracking) {
                ga(
                  'send',
                  'event',
                  'Button',
                  'Click',
                  'Login Created',
                  values?.amount,
                  { loginAmount: values?.amount }
                );
              }
            })
            .catch(error => {
              setShow(false);
            });
        };

        //get Api
        useEffect(() => {
          const getLoginDetails = async () => {
            if (lead_Id) {
              setType('loading');
              setText('Getting submitted data Please Wait...');
              setShow(true);
              setDontClose(true);

              getLoginDetailsApi(lead_Id)
                .then(async res => {
                  if (res?.error) {
                    throw new Error(res);
                  }
                  if (res) {
                    setResponse(res?.bankLoginDetails);
                    setDocResponse(res?.processingFeeDoc);
                    if (res?.bankLoginDetails) {
                      setShowAllDetails(true);
                    }
                  }
                  setShow(false);
                })

                .catch(err => {
                  setShow(false);
                });
            }
          };

          getLoginDetails();
        }, [lead_Id, showAllDetails]);

        useEffect(() => {
          const isFileRequired = async () => {
            if (values?.yesOrno) {
              await setFieldValue('isEditMode', false);
            } else {
              await setFieldValue('isEditMode', true);
            }
            validateForm();
          };
          isFileRequired();
        }, [values?.yesOrno]);

        return (
          <Form>
            <div className="md:ml-5 my-4 w-full md:w-7/12 px-2 md:bg-white min-h-screen md:py-2">
              <div className="flex pt-4">
                <p className="font-roboto md:px-8 md:block hidden font-semibold text-black-0 text-lg mr-auto">
                  Login Details
                </p>
              </div>
              <RejectedBankLogin leadId={lead_Id} />

              {!getresponse && (
                <Fragment>
                  <p className="w-full px-8 font-roboto font-medium text-base text-black-500 mt-6 -mb-2 md:-mb-4 ">
                    Add New Login.
                  </p>

                  <div
                    className={`${container_align} md:mx-auto px-6 md:p-4
                rounded-lg font-normal font-roboto text-sm text-black-500 bg-gray-200`}
                  >
                    <div className="my-6">
                      <CommonSelect sort={true}
                        name="city"
                        value={values.city}
                        onChange={e => {
                          setFieldValue('city', {
                            value: e.value,
                            label: e.label
                          });
                        }}
                        onBlur={() => {
                          setFieldTouched('city', true, true);
                        }}
                        options={cityOptions}
                        isHoverEffect
                        stylesContainer={{
                          marginBottom: '0px',
                          fontSize: '40px',
                          height: '52px'
                        }}
                        dropdownStyle={{
                          top: '52px',
                          color: 'rgba(0,0,0,0.87)',
                          fontSize: '16px',
                          backgroundColor: '#fff',
                          alignItems: 'center',
                          fontFamily: 'Roboto',
                          fontWeight: 400
                        }}
                        styleText={{
                          fontSize: '14px',
                          padding: '0 6px',
                          backgroundColor: 'white'
                        }}
                        error={touched.city && get(errors, 'city.value', false)}
                        touched={touched.city}
                      />
                    </div>
                    <div className="my-6">
                      <CommonSelect sort={true}
                        name="bankname"
                        value={values?.bankname}
                        onChange={e => {
                          setFieldValue('bankname', {
                            value: e.value,
                            label: e.label
                          });
                        }}
                        onBlur={() => {
                          setFieldTouched('bankname', true, true);
                        }}
                        options={bankListOptions}
                        isHoverEffect
                        stylesContainer={{
                          marginBottom: '0px',
                          fontSize: '40px',
                          height: '52px'
                        }}
                        dropdownStyle={{
                          top: '52px',
                          color: 'rgba(0,0,0,0.87)',
                          fontSize: '16px',
                          backgroundColor: '#fff',
                          alignItems: 'center',
                          fontFamily: 'Roboto',
                          fontWeight: 400
                        }}
                        styleText={{
                          fontSize: '14px',
                          padding: '0 6px',
                          backgroundColor: 'white'
                        }}
                        error={
                          touched.bankname &&
                          get(errors, 'bankname.value', false)
                        }
                        touched={touched.bankname}
                      />
                    </div>
                    <div className="my-6">
                      <CommonInput
                        name="fileID"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.fileID}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="File ID"
                        error={touched.fileID && errors.fileID}
                        errorMsg={errors.fileID}
                        touched={touched.fileID}
                      />
                    </div>
                    <div className="my-6">
                      <InputTypeNumber
                        name="amount"
                        maxLength={10}
                        minLength={0}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.amount}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="Login Amount"
                        error={touched.amount && errors.amount}
                        errorMsg={errors.amount}
                        touched={touched.amount}
                        showInText={false}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                    <div className="w-full md:col-span-2">
                      <p className="text-black-600 font-roboto font-normal text-xs pb-2 text-left">
                        Login Date
                      </p>

                      <CommonDatePicker
                        styleHeight={{
                          height: '52px'
                        }}
                        datePickerContainerstyle={{
                          gridTemplateColumns: '41% 27% 30%'
                        }}
                        onChangeMonth={(value, isValidDate) => {
                          setFieldValue('month', value, true);

                          setFieldTouched('month', true, false);
                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeYear={(value, isValidDate) => {
                          setFieldValue('year', value, true);
                          setFieldTouched('year', true, false);

                          if (!isValidDate) {
                            setFieldValue(
                              'date',
                              {
                                value: '',
                                label: 'Date'
                              },
                              true
                            );
                          }
                        }}
                        onChangeDate={value => {
                          setFieldValue('date', value, true);
                          setFieldTouched('date', true, false);
                        }}
                        valueMonth={values.month}
                        valueYear={values.year}
                        valueDate={values.date}
                        errorYear={
                          touched.year && get(errors, 'year.value', false)
                        }
                        touchedYear={touched.year}
                        onBlurYear={() => {
                          setFieldTouched('year', true, true);
                        }}
                        errorMonth={
                          touched.month && get(errors, 'month.value', false)
                        }
                        touchedMonth={touched.month}
                        onBlurMonth={() => {
                          setFieldTouched('month', true, true);
                        }}
                        // errors.date.value
                        errorDate={
                          touched.date && get(errors, 'date.value', false)
                        }
                        touchedDate={touched.date}
                        onBlurDate={() => {
                          setFieldTouched('date', true, true);
                        }}
                        disableFuture={true}
                        maxYear={parseInt(moment().format('YYYY'))}
                      />
                    </div>
                  </div>
                  <div className="px-10">
                    <p className="text-left pt-2 font-roboto text-sm  font-basic">
                      Processing fee is paid?
                    </p>
                    <div className="w-full flex mt-5 ">
                      <div className="flex items-center pr-10">
                        <RadioButton
                          name="yesOrno"
                          value={true}
                          checked={values?.yesOrno == true}
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('yesOrno', true);
                          }}
                          onBlur={handleBlur}
                        />
                        <label
                          htmlFor="yes"
                          className="text-black-400 text-sm m-2"
                        >
                          Yes
                        </label>
                      </div>

                      <div className="flex items-center">
                        <RadioButton
                          name="yesOrno"
                          value={false}
                          checked={values?.yesOrno == false}
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('yesOrno', false);
                          }}
                          onBlur={handleBlur}
                        />
                        <label
                          htmlFor="no"
                          className="text-black-400 text-sm m-2"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    {values?.yesOrno === true && (
                      <div className=" block ">
                        <p className="text-left font-roboto text-sm py-4 font-basic">
                          Upload Processing Fee Receipt
                        </p>

                        <GlobalUploadComp
                          data={values}
                          imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          // showFullImage={showFullImage}
                          initialImg={initialImg} // initial image
                          subInst="Click here to Upload "
                          subtext="CHOOSE FILE"
                        />
                      </div>
                    )}
                  </div>
                  <button
                    id="lems_loginLoginBtn"
                    className="submitButton w-48 block"
                    type="submit"
                    disabled={
                      !cityOptions.length > 0 ||
                      !bankListOptions.length > 0 ||
                      !_.isEmpty(errors)
                    }
                    onClick={saveLoginDetails}
                  >
                    Login
                  </button>
                </Fragment>
              )}
              {getresponse && (
                <React.Fragment>
                  {getresponse?.bankId ? (
                    <div className="w-full block bg-grey-200 rounded-md mx-8 max-w-xs my-3 shadow-md pl-1  bg-orange-200 float-left mr-4 mb-4 ">
                      <div
                        className="w-full py-1 px-3"
                        style={{ backgroundColor: '#F3FAFE' }}
                      >
                        <div
                          className={`w-full  mr-auto block ${
                            getDocResponse ? '' : 'pt-3'
                          }`}
                        >
                          <div className="w-full flex">
                            <div className="block w-6/12 text-left">
                              <p className="font-roboto font-normal text-black-500  mr-auto text-xs">
                                City
                              </p>
                              <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
                                {getresponse?.cityName}
                              </p>
                            </div>
                            <div className="block w-6/12 text-left">
                              <p className="font-roboto font-normal text-black-500 text-xs mr-auto">
                                Bank Name
                              </p>
                              <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
                                {getresponse?.bankName}
                              </p>
                            </div>
                          </div>
                          <div className="w-full flex mt-2">
                            <div className="block w-6/12 text-left">
                              <p className="font-roboto font-normal text-black-500 text-xs mr-auto">
                                File ID
                              </p>
                              <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
                                {getresponse?.fileId}
                              </p>
                            </div>
                            <div className="block w-6/12 text-left">
                              <p className="font-roboto font-normal text-black-500 text-xs mr-auto">
                                Login Amount
                              </p>
                              <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
                                &#8377;
                                {numberFormat(getresponse?.loginAmount || 0)}
                              </p>
                            </div>
                          </div>
                          <div className="w-full flex mt-2">
                            <div className="block w-6/12 text-left">
                              <p className="font-roboto font-normal text-black-500 text-xs mr-auto">
                                Login Date
                              </p>
                              <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
                                {getresponse?.loginDate
                                  ? moment(getresponse?.loginDate).format(
                                      'DD-MMM-YYYY'
                                    )
                                  : '----'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="pt-3 w-full flex my-1 items-center">
                          <div
                            className={`w-4/12 pr-3  float-left mr-4  ${logInDocBox}`}
                          >
                            {getDocResponse ? (
                              <div className=" bg-green-dim rounded  flex  items-center py-2 my-1 px-1">
                                <div
                                  className={`${rotatge_45_clock} mr-1 items-center`}
                                >
                                  <AttachFileIcon
                                    style={{
                                      color: '#16BF00',
                                      height: '17px',
                                      width: '17px'
                                    }}
                                  />
                                </div>
                                <div
                                  className="w-full items-center cursor-pointer"
                                  onClick={() => setFullImage(true)}
                                >
                                  <p className="font-roboto font-normal text-xs  text-green-flagGreen ">
                                    Processing Fee
                                  </p>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="w-full">
                          <HtmlTooltip
                            title={
                              <div>
                                <p className="font-roboto font-normal text-balck-500 text-xs ">
                                  You can again Login the lead to other bank
                                  after rejection.
                                </p>
                              </div>
                            }
                          >
                            <Button
                              onClick={() => setShowRejectModal(true)}
                              variant="outlined"
                              color="secondary"
                              className="font-roboto font-light my-4 py-2 px-4 mr-2 rounded cursor-pointer  normal-case "
                            >
                              Reject Lead
                            </Button>
                          </HtmlTooltip>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="font-roboot font-norml text-center text-sm">
                      No login Details Found!
                    </p>
                  )}
                </React.Fragment>
              )}
            </div>
            <ShowDoc
              file={getDocResponse?.url}
              show={fullImage}
              setShow={setFullImage}
              autoCheck={true}
            />
            <PopUp
              type={type}
              text={text}
              setShow={setShow}
              show={show}
              dontClose={dontClose}
              autoClose={type === 'success'}
            />
            <CMRejectLead show={showRejectModal} setShow={setShowRejectModal} />
          </Form>
        );
      }}
    </Formik>
  );
};
export default memo(withErrorHandler(LogInDetails));
